module.exports = __webpack_public_path__ + "img/logo-tripwe-new.ee6cd28f.svg";